export default __webpack_public_path__ + "static/budget_preparation-86ef89fdb3f913c36eed354ff7fc142c.png";